import { TemplateFieldsDisplayFn } from '../../../models/template.model';
import { CHINA_SUMMARY_COMMON } from './china-summary-common';

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...CHINA_SUMMARY_COMMON,
};
